import { render, staticRenderFns } from "./box3.vue?vue&type=template&id=5fe8eefc&scoped=true"
import script from "./box3.vue?vue&type=script&lang=js"
export * from "./box3.vue?vue&type=script&lang=js"
import style0 from "./box3.vue?vue&type=style&index=0&id=5fe8eefc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe8eefc",
  null
  
)

export default component.exports